export default "__VITE_ASSET__DW15gWBG__"